/*
 * @file: user.js
 * @description: Reducers and actions for store/manipulate user's  data
 * @date: 28.11.2019
 * @author: Anil
 */

/******** Reducers ********/

const initialState = {
    buyNewPhoneNumber: {
        loading: false,
        data: null,
        error: null,
        isSuccess: false
    },
    twilio_numbers: {
        data: null,
        error: null,
        loading: false
    },
    twilio_number_check: {
        data: null,
        error: null,
        loading: false
    }

};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        // buy twilio phone number
        case "BuyNewPhoneNumber_state_pending":
            return {
                ...state,
                buyNewPhoneNumber: {
                    loading: true,
                    data: null,
                    error: null,
                    isSuccess: false
                }
            };

        case "BuyNewPhoneNumber_state_success":
            return {
                ...state,
                buyNewPhoneNumber: {
                    loading: false,
                    data: action.payload,
                    error: null,
                    isSuccess: true
                }
            };


        case "BuyNewPhoneNumber_state_failed":
            return {
                ...state,
                buyNewPhoneNumber: {
                    loading: false,
                    data: null,
                    error: action.payload,
                    isSuccess: false
                }
            };

        // handle twilio phone numbers state
        // pending
        case "get_twilioPhone_pending":
            return {
                ...state,
                twilio_numbers: {
                    data: null,
                    error: null,
                    loading: true
                }
            };
        // sucess
        case "get_twilioPhone_success":
            return {
                ...state,
                twilio_numbers: {
                    data: action.payload,
                    error: null,
                    loading: false
                }
            };
        // failed
        case "get_twilioPhone_failed":
            return {
                ...state,
                twilio_numbers: {
                    data: null,
                    error: action.payload,
                    loading: false
                }
            };


        // check twilio phone number state
        case "checkTwilioPhone_pending":
            return {
                ...state,
                twilio_number_check: {
                    data: null,
                    error: null,
                    loading: true
                }
            };
        case "checkTwilioPhone_success":
            return {
                ...state,
                twilio_number_check: {
                    data: action.payload,
                    error: null,
                    loading: false
                }
            };
        case "checkTwilioPhone_failed":
            return {
                ...state,
                twilio_number_check: {
                    data: null,
                    error: "somethimg went wrong",
                    loading: false
                }
            };
        default:
            return state;
    }
}


